import type { PlatformUser } from '../platform/Platform';
import fakeUsers from '../leaderboard/fakeUsers.json';
import { shuffle } from '../../utils/array-utils';

export function getFakeUsers(amount: number): PlatformUser[] {
  return shuffle(fakeUsers.slice())
    .slice(0, amount)
    .map(({ name, avatarUrl }, index) => ({
      id: `fake_${index}`,
      name,
      currentUser: false,
      avatarUrl,
    }));
}
